import { useTranslation } from 'react-i18next'
import { cn } from './internal/utils'

const DefaultIllustration = ({ simple = false }) => (
  <svg
    viewBox="0 0 64 41"
    className={cn('ui-empty-img-default', simple ? 'h-8' : 'h-10')}
    aria-hidden="true"
  >
    <ellipse cx="32" cy="33" rx="32" ry="7" fill="var(--gray-300)" />
    <path
      d="M55 12.76L44.85 1.25A2.6 2.6 0 0042.9 0H21.1a2.6 2.6 0 00-1.95 1.25L9 12.76V22h46v-9.24z"
      fill="var(--gray-200)"
      stroke="var(--gray-400)"
    />
    <path
      d="M41.61 15.45c0-1.3.83-2.36 1.85-2.36H55V25.7a2.3 2.3 0 01-2.3 2.3H11.3A2.3 2.3 0 019 25.7V13.09h11.54c1.02 0 1.85 1.06 1.85 2.36v.1c0 1.3.84 2.35 1.86 2.35h15.5c1.02 0 1.86-1.06 1.86-2.36v-.09z"
      fill="var(--gray-100)"
      stroke="var(--gray-400)"
    />
  </svg>
)

const PRESENTED_IMAGE_SIMPLE = <DefaultIllustration simple />
const PRESENTED_IMAGE_DEFAULT = <DefaultIllustration />

/**
 * antd Empty. `image` accepts a node, a URL string, or one of the two presets.
 */
const Empty = ({
  image = PRESENTED_IMAGE_DEFAULT,
  imageStyle,
  description,
  className,
  style,
  children,
  ...rest
}) => {
  const { t } = useTranslation()
  const resolvedDescription = description === undefined ? t('common.noData') : description
  return (
  <div
    className={cn(
      'ui-empty flex flex-col items-center justify-center gap-2 px-4 py-6 text-center',
      className
    )}
    style={style}
    {...rest}
  >
    <div className="ui-empty-image flex items-center justify-center" style={imageStyle}>
      {typeof image === 'string' ? <img src={image} alt="" className="h-10" /> : image}
    </div>
    {resolvedDescription === false ? null : (
      <div className="ui-empty-description text-sm text-[var(--text-muted)]">{resolvedDescription}</div>
    )}
    {children ? <div className="ui-empty-footer">{children}</div> : null}
  </div>
  )
}

Empty.PRESENTED_IMAGE_DEFAULT = PRESENTED_IMAGE_DEFAULT
Empty.PRESENTED_IMAGE_SIMPLE = PRESENTED_IMAGE_SIMPLE

export default Empty
